const Footer =()=>{
    return(
        <>
    <div className="footer">
        <div className="container">
            <div className="row">
                <div className="col-md-4">
                    <div className="footer-col first">
                        <h4>About CoopXend</h4>
                        <p className="p-small">We're passionate about supporting our customers to keep and increase their money with less stress</p>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="footer-col middle">
                        <h4>Important Links</h4>
                        <ul className="list-unstyled li-space-lg p-small">
                            <li className="media">
                                <div className="media-body">Read our <a className="white" href="terms-conditions.html">Terms &amp; Conditions</a>, <a className="white" href="privacy-policy.html">Privacy Policy</a></div>
                            </li>
                        </ul>
                    </div>
                </div> 
                <div className="col-md-4">
                    <div className="footer-col last">
                        <h4>Contact</h4>
                        <ul className="list-unstyled li-space-lg p-small">
                            <li className="media">
                                <i className="fas fa-map-marker-alt"></i>
                                <div className="media-body">Federal University of Technology Minna Abuja, Nigeria</div>
                            </li>
                            <li className="media">
                                <i className="fas fa-envelope"></i>
                                <div className="media-body"><a className="white" href="mailto:info@coopxend.com">info@coopxend.com</a> <br/> <i className="fas fa-globe"></i><a className="white" href="#your-link">www.coopxend.com</a></div>
                            </li>
                        </ul>
                    </div> 
                </div>
            </div>
        </div>
    </div>
        </>
    )
}

export default Footer;